import { Users as UsersIcon, type LucideIcon } from 'lucide-react';
import { Item, ItemContent, ItemDescription, ItemMedia, ItemTitle } from '@bliks-io/ui';
import type { EntitySuggestion, EntitySuggestionKind } from '@bliks-io/contracts';
import { ENTITY_ICONS } from '@/constants/entityIcons';

interface GhostSuccessorItemProps {
  suggestion: EntitySuggestion;
}

const ICON_BY_KIND: Record<EntitySuggestionKind, LucideIcon> = {
  system: ENTITY_ICONS.system,
  orgFunction: UsersIcon
};

/**
 * Successor row for a pending entity suggestion. Visually identical to
 * SystemSuccessorItem / TeamSuccessorItem except for the dashed border, which
 * is the sole signal that the entity is unresolved. Wrap with
 * <SuccessorListItem> to add the dismiss X.
 */
export function GhostSuccessorItem({ suggestion }: GhostSuccessorItemProps) {
  const Icon = ICON_BY_KIND[suggestion.kind];
  const description = suggestion.payload.description;

  return (
    <Item variant="outline" size="default" className="pr-8 border-dashed">
      <ItemMedia variant="icon">
        <Icon className="h-4 w-4" />
      </ItemMedia>
      <ItemContent>
        <ItemTitle>{suggestion.payload.name}</ItemTitle>
        {description && <ItemDescription>{description}</ItemDescription>}
      </ItemContent>
    </Item>
  );
}
